import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      quote: "Tri County Ninja has been life-changing for our family. My kids have gained so much confidence and strength, and they absolutely love coming to class every week. The coaches are amazing and the facility is top-notch!",
      name: "Sarah Mitchell",
      role: "Parent of 2 Ninjas",
      avatar: "https://public.readdy.ai/ai/img_res/050d41e31951a846678d3c0d7f3f7527.jpg"
    },
    {
      id: 2,
      quote: "As an adult looking for a fun and challenging workout, Tri County Ninja exceeded all my expectations. The obstacle training is addictive, the community is supportive, and I've never been in better shape. Highly recommend!",
      name: "Marcus Johnson",
      role: "Adult Ninja Member",
      avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20athletic%20fit%20man%20in%20his%2030s%20with%20confident%20smile%20on%20simple%20clean%20white%20background%2C%20natural%20lighting%20portrait%20photography&width=200&height=200&seq=testimonial-adult-021&orientation=squarish"
    },
    {
      id: 3,
      quote: "We hosted my daughter's 10th birthday party here and it was absolutely perfect! The staff took care of everything, the kids had a blast on the obstacles, and it was stress-free for us parents. Best party venue ever!",
      name: "Jennifer Lee",
      role: "Birthday Party Host",
      avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20cheerful%20woman%20in%20her%2030s%20with%20bright%20smile%20on%20simple%20clean%20white%20background%2C%20natural%20lighting%20portrait%20photography&width=200&height=200&seq=testimonial-party-022&orientation=squarish"
    },
    {
      id: 4,
      quote: "My son was shy and hesitant at first, but the coaches at Tri County Ninja were so patient and encouraging. Now he's one of the most confident kids in his class and he's made great friends. Thank you for everything!",
      name: "David Chen",
      role: "Parent of Teen Ninja",
      avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20friendly%20asian%20man%20in%20his%2040s%20with%20warm%20smile%20on%20simple%20clean%20white%20background%2C%20natural%20lighting%20portrait%20photography&width=200&height=200&seq=testimonial-teen-parent-023&orientation=squarish"
    },
    {
      id: 5,
      quote: "Our company did a team building event at Tri County Ninja and it was fantastic! The activities were challenging but accessible for all fitness levels, and our team bonded in ways we never expected. Will definitely be back!",
      name: "Amanda Rodriguez",
      role: "Corporate Team Leader",
      avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20confident%20businesswoman%20in%20her%2030s%20with%20professional%20smile%20on%20simple%20clean%20white%20background%2C%20natural%20lighting%20portrait%20photography&width=200&height=200&seq=testimonial-corporate-024&orientation=squarish"
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index: number) => {
    setActiveIndex(index);
  };

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="mb-4">
            <span className="text-[#FF6B35] text-sm font-bold uppercase tracking-wider">
              Testimonials
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-[#0A1628]">
            What Our Ninjas Say
          </h2>
        </div>

        {/* Testimonial Carousel */}
        <div className="relative max-w-5xl mx-auto">
          {/* Side Preview Cards - Hidden on Mobile */}
          <div className="hidden lg:block absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-32 w-80 opacity-30 scale-85">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="text-[#FF6B35] text-6xl mb-4">"</div>
              <p className="text-gray-600 line-clamp-3">
                {testimonials[(activeIndex - 1 + testimonials.length) % testimonials.length].quote}
              </p>
            </div>
          </div>

          <div className="hidden lg:block absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-32 w-80 opacity-30 scale-85">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="text-[#FF6B35] text-6xl mb-4">"</div>
              <p className="text-gray-600 line-clamp-3">
                {testimonials[(activeIndex + 1) % testimonials.length].quote}
              </p>
            </div>
          </div>

          {/* Main Active Card */}
          <div className="bg-white rounded-3xl p-12 md:p-16 shadow-2xl relative">
            {/* Opening Quote */}
            <div className="text-[#FF6B35] text-8xl md:text-9xl font-serif absolute top-8 left-8 opacity-50">
              "
            </div>

            {/* Quote Text */}
            <div className="relative z-10 mb-12">
              <p className="text-[#0A1628] text-xl md:text-2xl leading-relaxed text-center max-w-3xl mx-auto">
                {testimonials[activeIndex].quote}
              </p>
            </div>

            {/* Closing Quote */}
            <div className="text-[#FF6B35] text-8xl md:text-9xl font-serif absolute bottom-8 right-8 opacity-50">
              "
            </div>

            {/* Attribution */}
            <div className="text-center relative z-10">
              <img
                src={testimonials[activeIndex].avatar}
                alt={testimonials[activeIndex].name}
                className="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
              />
              <h4 className="text-xl font-bold text-[#0A1628] mb-1">
                {testimonials[activeIndex].name}
              </h4>
              <p className="text-gray-600">
                {testimonials[activeIndex].role}
              </p>
            </div>
          </div>

          {/* Navigation Arrows */}
          <div className="flex justify-center gap-4 mt-8 md:hidden">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#FF6B35] hover:text-white transition-all duration-300 group cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl text-[#0A1628] group-hover:text-white"></i>
            </button>
            <button
              onClick={nextTestimonial}
              className="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#FF6B35] hover:text-white transition-all duration-300 group cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl text-[#0A1628] group-hover:text-white"></i>
            </button>
          </div>
          <button
            onClick={prevTestimonial}
            className="hidden md:flex absolute -left-20 top-1/2 transform -translate-y-1/2 w-14 h-14 bg-white rounded-full shadow-lg items-center justify-center hover:bg-[#FF6B35] hover:text-white transition-all duration-300 group cursor-pointer"
          >
            <i className="ri-arrow-left-line text-2xl text-[#0A1628] group-hover:text-white"></i>
          </button>
          <button
            onClick={nextTestimonial}
            className="hidden md:flex absolute -right-20 top-1/2 transform -translate-y-1/2 w-14 h-14 bg-white rounded-full shadow-lg items-center justify-center hover:bg-[#FF6B35] hover:text-white transition-all duration-300 group cursor-pointer"
          >
            <i className="ri-arrow-right-line text-2xl text-[#0A1628] group-hover:text-white"></i>
          </button>

          {/* Dot Indicators */}
          <div className="flex justify-center mt-12 space-x-3">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  index === activeIndex
                    ? 'bg-[#FF6B35] w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}